var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "flex-container" },
    [
      _c("div", { staticClass: "forgot-whitebox" }, [
        _c("h1", [_vm._v("Resend Verification Link")]),
        _c("p", { staticClass: "desc" }, [
          _vm._v(
            " Enter your email address and we will send you a new verification link. "
          ),
        ]),
        _c("div", { staticClass: "forgot-container" }, [
          _c("div", { staticClass: "forgot-input" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.email,
                  expression: "email",
                },
              ],
              staticClass: "forgot-input-box required form-control",
              attrs: { type: "email", placeholder: "E-mail address" },
              domProps: { value: _vm.email },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.email = $event.target.value
                },
              },
            }),
            _c("i", { staticClass: "fa fa-envelope" }),
          ]),
        ]),
        _vm.errorMessage
          ? _c("div", { staticClass: "error-msg-holder" }, [
              _c("span", {
                staticClass: "error-message",
                domProps: { innerHTML: _vm._s(_vm.errorMessage) },
              }),
              _c("br"),
            ])
          : _vm._e(),
        _c(
          "button",
          {
            staticClass: "btn mt-20 emergo-green-button",
            attrs: {
              type: "button",
              disabled: _vm.disableButton || _vm.disableBtn,
            },
            on: { click: _vm.postEmail },
          },
          [_vm._v(" " + _vm._s(_vm.btnTxt) + " ")]
        ),
        _vm._m(0),
      ]),
      _c("verification-popup"),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "desc mt-20" }, [
      _vm._v(" Please contact RAMS Support at "),
      _c("a", { attrs: { href: "mailto:ramshelp@ul.com" } }, [
        _vm._v("ramshelp@ul.com"),
      ]),
      _vm._v(" in case you have not received the new verification link. "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }